export default {
  generic: {
    enlarge: 'Cliquez pour agrandir',
  },
  pages: {
    home: {
      location: 'ligging',
      see_all_gites: 'Voir tous les hébergements',
      see_all_massages: 'Tous les massages',
      domain: {
        view_domain: 'Découvrir le domaine',
      },
    },
    wellness: {
      all_massages: 'Tous les massages',
    },
    contact: {
      location: 'Ligging',
      contact: 'Nous contacter',
      name: 'Nom et Prénom',
      email: 'E-mail',
      telephone: 'Téléphone',
      message: 'Message',
      send: 'Envoyer',
      required: 'obligatoire',
      reachability: 'Comment venir?',
    },
  },
  gites: {
    overview: {
      crumb: 'Gîtes et Glamping Lodges',
      title: 'Gîtes et Glamping Lodges',
      discover: 'découvrir',
    },
    detail: {
      pictures: 'Les photos',
      facilities: 'Descriptif',
      book_directly: 'Réserver maintenant',
      from: 'Arrivée',
      and: 'et',
      to: 'Départ',
      show_availability: 'Disponibilités',
      availability: 'Disponibilités',
      virtual_tour: 'Tour virtuel',
    },
  },
  footer: {
    name: "Aux Quatrefeuilles d'Oc",
    help: 'Infos pratiques',
    social: 'Retrouvez nous sur',
    partner: 'Partenaire officiel de',
    reachable: 'Joignable par',
    copyright: 'Copyright',
    rights: 'tous droits réservés',
  },
  components: {
    map: {
      calculate_route: 'Calculer mon itinéraire',
      view_on_google_maps: 'Vers Google Maps',
    },
    reviews: {
      title: 'Ce que disent les autres',
      more: "Découvrir plus d'avis",
    },
    widget: {
      search: 'Disponibilité',
      arrival: 'Arrivée',
      departure: 'Départ',
      close: 'Fermer',
    },
  },
  groups: {
    more_information: "Plus d'infos",
    more_information_body:
      "N'hésitez pas à nous contacter pour plus d'informations ou pour un devis détaillé.",
  },
  error: {
    main_title: 'Page non trouvée',
    title:
      "La page n'a pas pu être chargée. Actualisez votre navigateur pour recharger la page. Si le problème persiste, veuillez nous contacter.",
    body: "Retour à l'accueil",
  },
}
